import React from 'react';

import { DirectoryUpdate } from '../DirectoryUpdate';

export const Footer = () => (
  <React.Fragment>
    <DirectoryUpdate />
  </React.Fragment>
);
